@if (sap().port; as port) {
  <div class="tabs__grid-item">
    <port-summary
      [service]="port"
      [subscriptionInstanceId]="sap().subscriptionInstanceId"
      [vlanranges]="sap().vlanrange ? [sap().vlanrange] : []"
      [forceTrafficBottom]="hasConfigurationDetails()"
      style="width: 100%"
    />
  </div>
}

@if (hasConfigurationDetails()) {
  <div class="tabs__grid-item">
    <configuration-details
      [configurationDetails]="configurationDetails()"
      [isInfrastructureDelegate]="false"
      [firewallEnabled]="false"
    />
  </div>
}
